const IMAGES_PATH = '/assets/images';

export const header = `${IMAGES_PATH}/header.jpg`;
export const logo = `${IMAGES_PATH}/logo.png`;
export const burger = `${IMAGES_PATH}/burger.jpg`;
export const drink = `${IMAGES_PATH}/drink.jpg`;
export const back = `${IMAGES_PATH}/back.png`;
export const email = `${IMAGES_PATH}/email.png`;
export const location = `${IMAGES_PATH}/location.png`;
export const paypal = `${IMAGES_PATH}/paypal.png`;
export const cash = `${IMAGES_PATH}/cash.png`;
export const mpesa = `${IMAGES_PATH}/mpesa.jpg`;
export const shopping = `${IMAGES_PATH}/shopping.png`;
export const account = `${IMAGES_PATH}/account.png`;
export const menu = `${IMAGES_PATH}/menu.png`;

// food images
export const chicken = `${IMAGES_PATH}/chicken.png`;
export const pizza = `${IMAGES_PATH}/pizza.png`;
export const salad = `${IMAGES_PATH}/salad.png`;
export const pork = `${IMAGES_PATH}/pork.png`;
export const fish = `${IMAGES_PATH}/fish.png`;
export const fries = `${IMAGES_PATH}/fries.png`;
export const steak = `${IMAGES_PATH}/steak.png`;
export const rice = `${IMAGES_PATH}/rice.png`;
export const pasta = `${IMAGES_PATH}/pasta.png`;
export const mashed = `${IMAGES_PATH}/mashed.png`;

//drinks images
export const cocacola = `${IMAGES_PATH}/cocacola.png`;
export const juice = `${IMAGES_PATH}/juice.png`;
export const water = `${IMAGES_PATH}/water.png`;
export const energy = `${IMAGES_PATH}/energy.png`;
export const coffee = `${IMAGES_PATH}/coffee.png`;
export const tea = `${IMAGES_PATH}/tea.png`;
export const milkshake = `${IMAGES_PATH}/milkshake.png`;
export const beer = `${IMAGES_PATH}/beer.png`;
export const alcohol = `${IMAGES_PATH}/alcohol.png`;
export const wine = `${IMAGES_PATH}/wine.png`;

//Fruit images
export const bananas = `${IMAGES_PATH}/bananas.png`;
export const apple = `${IMAGES_PATH}/apple.png`;
export const orange = `${IMAGES_PATH}/orange.png`;
export const pear = `${IMAGES_PATH}/pear.png`;
export const grape = `${IMAGES_PATH}/grape.png`;
export const papaya = `${IMAGES_PATH}/papaya.png`;
export const passion = `${IMAGES_PATH}/passion.png`;
export const watermelon = `${IMAGES_PATH}/watermelon.png`;
export const avocado = `${IMAGES_PATH}/avocado.png`;
export const peach = `${IMAGES_PATH}/peach.png`;

//Dessert images
export const cake = `${IMAGES_PATH}/cake.png`;
export const donut = `${IMAGES_PATH}/donut.png`;
export const icecream = `${IMAGES_PATH}/icecream.png`;
export const jelly = `${IMAGES_PATH}/jelly.png`;
export const cupcake = `${IMAGES_PATH}/cupcake.png`;
export const cookie = `${IMAGES_PATH}/cookie.png`;
export const pancakes = `${IMAGES_PATH}/pancakes.png`;
export const waffles = `${IMAGES_PATH}/waffles.png`;
export const chips = `${IMAGES_PATH}/chips.png`;
export const nachos = `${IMAGES_PATH}/nachos.png`;
